await import(`@liferay/language/${Liferay.ThemeDisplay.getLanguageId()}/accessibility-menu-web/all.js`);
/**
 * SPDX-FileCopyrightText: (c) 2000 Liferay, Inc. https://liferay.com
 * SPDX-License-Identifier: LGPL-2.1-or-later OR LicenseRef-Liferay-DXP-EULA-2.0.0-2023-06
 */

const openAccessibilityMenu = () => {
	Liferay.fire('openAccessibilityMenu');
};

export default openAccessibilityMenu;
